class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.headerComponent = document.querySelector(".header");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.closeTimeout = null;

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add("animate", "active");

    if (this.headerComponent.classList.contains("header--relative")) {
      this.notification.style.top = "0";
    } else if (this.headerComponent.classList.contains("header--absolute")) {
      this.notification.style.top = "6.5rem";
    }

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);

    // Close notification after 5 seconds
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 3500);
  }

  close() {
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    // Ajout : remplacer le contenu par l'image et le texte uniquement
    const productDiv = document.getElementById("cart-notification-product");
    if (productDiv) {
      // Récupérer les informations du produit depuis le panier
      let productTitle = "";
      let imageHtml = "";

      // Essayer d'abord depuis parsedState.product_title
      if (parsedState && parsedState.product_title) {
        productTitle = parsedState.product_title;
      }

      // Essayer d'abord depuis parsedState.featured_image
      if (parsedState && parsedState.featured_image) {
        imageHtml = `<div class="cart-notification-product__image global-media-settings">
          <img src="${parsedState.featured_image.url}" alt="" loading="lazy" width="200" height="200" />
        </div>`;
      }

      // Si pas de titre dans parsedState, essayer de le récupérer depuis les items du panier
      if (
        !productTitle &&
        parsedState &&
        parsedState.items &&
        parsedState.items.length > 0
      ) {
        const firstItem = parsedState.items[0];
        productTitle = firstItem.product_title || firstItem.title || "Produit";

        // Si pas d'image dans parsedState, essayer de la récupérer depuis le premier item
        // if (!imageHtml && firstItem.featured_image) {
        //   imageHtml = `<div class="cart-notification-product__image global-media-settings">
        //     <img src="${firstItem.featured_image.url}" alt="" loading="lazy" width="200" height="200" />
        //   </div>`;
        // }
      }

      // Fallback si toujours pas de titre
      if (!productTitle) {
        productTitle = "Produit";
      }

      const message = `${productTitle} ${
        window.cartStrings?.productAddedNotification ||
        "a été ajouté à votre panier"
      }`;

      productDiv.innerHTML = `
        ${imageHtml}
        <div class="cart-notification-product__message">
          <span class="ft-body-2 font-semibold">${message}</span>
          <a
            href="/cart"
            id="cart-notification-button"
            class="ft-body-2 text-grey"
            
          >
            Voir le panier
          </a>
        </div>
      `;
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
